import { BASE_URL, fetchWithAuth } from "./client";

export async function fetchCreditPacks() {
  const response = await fetch(`${BASE_URL}/api/subscriptions/credit-packs`, {
    headers: { accept: "application/json" }
  });
  if (!response.ok) {
    const errorText = await response.text().catch(() => "Unknown error");
    throw new Error(`Failed to load credit packs: ${errorText}`);
  }
  return response.json();
}

export async function fetchSubscriptionPlans() {
  const response = await fetch(`${BASE_URL}/api/subscriptions/plans`, {
    headers: { accept: "application/json" }
  });
  if (!response.ok) {
    const errorText = await response.text().catch(() => "Unknown error");
    throw new Error(`Failed to load subscription plans: ${errorText}`);
  }
  return response.json();
}

